export class HealthCardNumberMaskedFormatter {
    public static format(cardNumber: string, country: string, region: string): string {
        // Apply masking logic here
        if (country === "CA" && region === "ON")
            return this.formatOntarioHealthCardNumber(cardNumber);

        return cardNumber.replace(/\s|\(|\)|_|-|\+/g, '');
    }

    public static formatOntarioHealthCardNumber(cardNumber: string): string {
        // Apply specific formatting logic for Ontario health card numbers
        const cardNumberFormatted = cardNumber.replace(/\s|\(|\)|_|-|\+/g, '');;

        if (cardNumberFormatted.length === 10)
            return cardNumberFormatted;

        const healthCardNumber = cardNumberFormatted.substring(0, 10);
        const version = cardNumberFormatted.substring(10, 12);

        return `${healthCardNumber}-${version}`;
    }
}


// WEBPACK FOOTER //
// ./src/components/AcquireHealthCardNumber/HealthCardNumberMaskedFormatter.ts